// extracted by mini-css-extract-plugin
export default {"top":"Skills_top__kocYG","skillcard":"Skills_skillcard__XMBNE","singleCard":"Skills_singleCard__08FxJ"};